import { useEffect, useState } from "react";
import { apiGet } from "@/lib/api";
import { kindChip, localTimeKey } from "@/lib/terminalUtils";

const label = { valid: "VALID SETUP", sweep: "SWEEP", mss: "MSS/BOS", displacement: "DISPLACEMENT", invalidated: "INVALIDATED" };

export const AlertsTable = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () => apiGet("/events").then((r) => alive && setItems(r.data.items.slice(0, 12))).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <div className="border border-white/10 bg-[#0d1219]" data-testid="alerts-table">
      <div className="flex items-center justify-between border-b border-white/10 px-4 py-3">
        <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">Recent Alerts</p>
        <span className="font-mono text-[9px] text-brand">{items.length} event</span>
      </div>
      <div className="divide-y divide-white/5">
        {items.length === 0 ? (
          <p className="px-4 py-6 text-center font-mono text-[11px] text-mute-dim">menunggu event pertama dari engine...</p>
        ) : (
          items.map((ev) => (
            <div key={ev.id} className="flex items-center justify-between gap-3 px-4 py-2.5">
              <span className="font-mono text-[10px] text-mute-dim">{ev.created_at ? localTimeKey(ev.created_at) : "—"}</span>
              <span className="flex-1 truncate font-mono text-[11px] text-white">
                <span className="text-mute-dim">[{ev.symbol}]</span> {ev.text}
              </span>
              <span className={`border px-2 py-0.5 font-mono text-[9px] font-bold ${kindChip(ev.kind)}`}>
                {label[ev.kind] || ev.kind?.toUpperCase()}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
